import React, { useState } from 'react';

import { ReviewForm } from '@portal/components/review/form';
import { Rating, Review__ReviewableEnum } from '@portal/schema';

import { ReviewSubmitted } from './review_submitted';

export const Review: React.FC<{
  reviewableID: string;
  rating?: Rating;
  kind?: string;
  schedulingID?: string;
}> = ({ reviewableID, rating, kind, schedulingID }) => {
  const [selectedRating, setSelectedRating] = useState<Rating | undefined>(rating);
  const [submitted, setSubmitted] = useState<boolean>(false);

  if (submitted) {
    return <ReviewSubmitted rating={selectedRating!} />;
  }

  return (
    <ReviewForm
      title="Did you receive everything?"
      selectedRating={selectedRating}
      setSelectedRating={setSelectedRating}
      reviewable={{ id: reviewableID, type: Review__ReviewableEnum.LogisticsOutboundLoad }}
      onSubmission={() => setSubmitted(true)}
      kind={kind}
      schedulingID={schedulingID}
    />
  );
};
Review.displayName = 'LogisticsLoadReview';
